import React from "react";
import { arc, scaleLinear } from "d3";

export const GaugeRegionalArc = ({ id, value, isNegative }) => {
    const startColor = !!isNegative ? "#F33A69" : "#54D2C7";
    const endColor = !!isNegative ? "#FE68AC" : "#6EEDB8";

    const percentScale = scaleLinear().domain([0, 100]).range([0, 1]);

    const percent = value => percentScale(value);

    const angleScale = scaleLinear()
        .domain([0, 1])
        .range([-Math.PI / 2, Math.PI / 2])
        .clamp(true);

    const regionalAngle = angleScale(percent(value));

    const filledArc = arc()
        .innerRadius(0.85)
        .outerRadius(1)
        .startAngle(-Math.PI / 2)
        .endAngle(regionalAngle);

    return (
        <g>
            <defs>
                <linearGradient
                    id={`Gauge__gradient${id}`}
                    gradientUnits="userSpaceOnUse"
                    x1="-1"
                    x2="1"
                    y2="0"
                >
                    <stop offset="5%" stopColor={startColor} />
                    <stop offset="95%" stopColor={endColor} />
                </linearGradient>
            </defs>
            <path d={filledArc(null)} fill={`url(#Gauge__gradient${id})`} />
        </g>
    );
};
